import { gql } from '@apollo/client';

export const GET_MEMBER_ASSOCIATION = gql`
  query GetMemberAssociation {
    memberAssociation
  }
`;

export const GET_MEMBER_ASSOCIATIONS = gql`
  query GetMemberAssociations {
    memberAssociations {
      settingKey
      societyId
      memberId
      memberIdent
    }
  }
`;

export const LOOKUP_MEMBERS_BY_IDS = gql`
  query LookupMembersByIds($members: [MemberLookupInput!]!) {
    lookupMembersByIds(members: $members) {
      memberId
      societyId
      memberIdent
      memberName
    }
  }
`;
